const BRAND_HEADER = `
  <div class="brand">
    <div class="brand-name">Studio</div>
    <div class="brand-sign">by Instan.t</div>
  </div>`;

const STYLE = `
  @page { margin: 22mm 18mm; }
  * { box-sizing: border-box; }
  body { font-family: "DM Sans", -apple-system, Helvetica, Arial, sans-serif; color: #0A0A0A; margin: 0; }
  .brand { border-bottom: 1px solid #E5E5E1; padding-bottom: 14px; margin-bottom: 28px; }
  .brand-name { font-family: "Instrument Serif", Georgia, serif; font-size: 28px; line-height: 1; }
  .brand-sign { font-size: 10px; letter-spacing: .18em; text-transform: uppercase; color: #74766F; margin-top: 6px; }
  h1 { font-family: "Instrument Serif", Georgia, serif; font-weight: 400; font-size: 24px; margin: 0 0 4px; }
  .sub { font-size: 11px; letter-spacing: .1em; text-transform: uppercase; color: #74766F; margin-bottom: 26px; }
  .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px 28px; }
  .field { border-bottom: 1px solid #E5E5E1; padding-bottom: 8px; }
  .k { font-size: 9px; letter-spacing: .18em; text-transform: uppercase; color: #74766F; margin-bottom: 5px; }
  .v { font-size: 13px; }
  .full { grid-column: 1 / -1; }
  .box { border: 1px solid #E5E5E1; padding: 14px; min-height: 90px; margin-top: 8px; }
  .foot { margin-top: 34px; font-size: 9px; letter-spacing: .12em; text-transform: uppercase; color: #74766F; border-top: 1px solid #E5E5E1; padding-top: 10px; }
  .accent { color: #272E23; }
`;

function field(label, value, full = false) {
  if (!value && value !== 0) return "";
  return `<div class="field ${full ? "full" : ""}"><div class="k">${label}</div><div class="v">${value}</div></div>`;
}

function render(title, subtitle, body) {
  const date = new Date().toLocaleString("fr-FR");
  const html = `<!doctype html><html lang="fr"><head><meta charset="utf-8" />
    <title>${title} — Studio by Instan.t</title>
    <link href="https://fonts.googleapis.com/css2?family=Instrument+Serif&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />
    <style>${STYLE}</style></head><body>
    ${BRAND_HEADER}
    <h1>${title}</h1>
    <div class="sub">${subtitle}</div>
    ${body}
    <div class="foot">Document généré par Studio by Instan.t · ${date}</div>
    </body></html>`;

  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 600);
  return true;
}

export function printProspect(p) {
  const body = `<div class="grid">
    ${field("SIRET", p.siret)}
    ${field("Code NAF", `${p.code_naf || "—"} ${p.libelle_naf ? "· " + p.libelle_naf : ""}`)}
    ${field("Adresse", `${p.adresse || ""}${p.code_postal ? ", " + p.code_postal : ""} ${p.ville || ""}`, true)}
    ${field("Effectif", p.effectif_label)}
    ${field("Ancienneté", p.age_years ? `${p.age_years} ans` : "")}
    ${field("Téléphone", p.google_phone)}
    ${field("Site web", p.google_website)}
    ${field("Note Google", p.google_rating ? `${p.google_rating} / 5 · ${p.google_reviews_count || 0} avis` : "")}
    ${field("Score de priorité", `<span class="accent">${p.priority_score}/100</span>`)}
    ${field("Chiffre d'affaires", p.ca ? `${new Intl.NumberFormat("fr-FR").format(p.ca)} €${p.finances_year ? " (" + p.finances_year + ")" : ""}` : "")}
    ${field("Dirigeant", p.dirigeant_principal)}
    ${field("Dirigeants (RNE)", (p.dirigeants || []).map((d) => `${d.prenoms || ""} ${d.nom || ""}${d.qualite ? " — " + d.qualite : ""}`.trim()).join("<br/>"), true)}
    ${field("Statut", p.status)}
    ${field("Prochaine action", p.next_action_at ? new Date(p.next_action_at).toLocaleString("fr-FR") : "")}
    ${field("Notes", (p.notes || "").replace(/\n/g, "<br/>"), true)}
  </div>`;
  return render(p.nom || "Fiche prospect", "Fiche prospect", body);
}

export function printCallSheet(p) {
  const body = `<div class="grid">
    ${field("Entreprise", p.nom)}
    ${field("Téléphone", p.google_phone || "—")}
    ${field("Ville", `${p.ville || ""} ${p.code_postal ? "· " + p.code_postal : ""}`)}
    ${field("Activité", p.libelle_naf)}
    ${field("Score", `<span class="accent">${p.priority_score}/100</span>`)}
    ${field("Dirigeant", p.dirigeant_principal || "—")}
    ${field("Chiffre d'affaires", p.ca ? `${new Intl.NumberFormat("fr-FR").format(p.ca)} €${p.finances_year ? " (" + p.finances_year + ")" : ""}` : "—")}
    ${field("Site web", p.google_website || "—")}
    <div class="full"><div class="k">Interlocuteur / rôle</div><div class="box"></div></div>
    <div class="full"><div class="k">Besoin détecté</div><div class="box"></div></div>
    <div class="full"><div class="k">Objections / points à préparer</div><div class="box"></div></div>
    <div class="full"><div class="k">Suite à donner (RDV / rappel / note)</div><div class="box"></div></div>
  </div>`;
  return render(p.nom || "Fiche d'appel", "Fiche d'appel · call center", body);
}

export function printEvent(ev) {
  const body = `<div class="grid">
    ${field("Type", ev.type === "rdv" ? "Rendez-vous commercial" : "Rappel téléphonique")}
    ${field("Date", new Date(ev.start).toLocaleString("fr-FR"))}
    ${field("Entreprise", ev.prospect_nom)}
    ${field("Téléphone", ev.prospect_phone)}
    ${field("Lieu / lien", ev.location)}
    ${field("Interlocuteur", `${ev.interlocuteur || ""} ${ev.interlocuteur_role ? "· " + ev.interlocuteur_role : ""}`)}
    ${field("Budget estimé", ev.budget)}
    ${field("Urgence", ev.urgence)}
    ${field("Besoin détecté", ev.besoin, true)}
    ${field("Objections / points à préparer", ev.objections, true)}
    ${field("Motif", ev.motif, true)}
    ${field("Note", ev.note, true)}
    ${field("Assigné à", ev.assigned_to)}
  </div>`;
  return render(ev.title || "Rendez-vous", ev.type === "rdv" ? "Fiche rendez-vous" : "Fiche rappel", body);
}
